import styled from "styled-components";

export const SModuleImage = styled.img`
  border-radius: 8px;
  box-shadow: 2px 4px 12px 0px rgba(24, 42, 51, 0.12);
  margin-right: 6px;
`;
